// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"dJ-z","tooltipWrapper":"eJ-z","icon":"fJ-z","tooltip":"gJ-z","content":"hJ-z"};